import { adminHttpClient } from '../../../../../commons/adminHttpClient'

type SelectReimburseAnotherEmployersPlan = {
  productClassId: string
  reimburseAnotherEmployersPlan: boolean
}

const setSelectReimburseAnotherEmployersPlan = (values: SelectReimburseAnotherEmployersPlan): Promise<string[]> => {
  return adminHttpClient.post('AdminDashboard/qsehra/ClassDesign/SelectReimburseAnotherEmployersPlan', values)
}

export default setSelectReimburseAnotherEmployersPlan
